import { createGradientTexture } from '../utils/gradientTexture';

PIXI.Texture.addToCache(createGradientTexture(500,500),'gradient');
